<div class="BottomBarContent Grid Align--center">
  <div class="LeftContainer Flexbox Align--center">
    @if (logo()) {
      <img class="CustomerLogo LargeLogo" [src]="logo()!" alt="Retailer Logo">
    }
  </div>
  <div class="MiddleContainer Flexbox Justify--center Align--center">
    @if (logo()) {
      <img class="CustomerLogo MediumLogo" [src]="logo()!" alt="Retailer Logo">
    }
    <button mat-button color="warn" (click)="reset()">
      <div class="Flexbox Flexbox--column Align--center">
        <mat-icon>restart_alt</mat-icon>
        <span>Reset</span>
      </div>
    </button>
    <button mat-button [disabled]="!canUndo()" (click)="undo()">
      <div class="Flexbox Flexbox--column Align--center">
        <mat-icon>undo</mat-icon>
        <span>Undo</span>
      </div>
    </button>
    <button mat-button [disabled]="!canRedo()" (click)="redo()">
      <div class="Flexbox Flexbox--column Align--center">
        <mat-icon>redo</mat-icon>
        <span>Redo</span>
      </div>
    </button>
    <button mat-button (click)="toggleBookmark()">
      <div class="Flexbox Flexbox--column Align--center">
        <mat-icon class="ThemeColorPrimary">
          @if (!isBookmarkKeyInBookmarks(this.bookmarkKey())) {
            favorite_outline
          } @else {
            favorite
          }
        </mat-icon>
        <span>@if (!isBookmarkKeyInBookmarks(this.bookmarkKey())) {Favorite} @else {Unfavorite}</span>
      </div>
    </button>
  </div>
  <div class="RightContainer Flexbox Justify--flex-end Align--center">
      <div class="ReviewContainer Flexbox Justify--center Align--center">
        <div class="Flexbox Align--center Gap--normal">
          <!-- <span class="ItemNumber">{{ skuToShow() }}</span> -->
          <div class="Flexbox Flexbox--column Align--flex-start Gap--tiny">
            @if (shouldShowPrice()) {
              <div class="PriceContainer Flexbox Flexbox--column Justify--space-between Gap--smaller">
                @if (isRetailerMode()) {
                  <app-price [price]="retailPrice()" [type]="'retailer'"></app-price>
                } @else {
                  @if (shouldShowWholesalePrice()) {
                    <app-price [price]="wholesalePriceToShow()" [type]="'wholesale'"></app-price>
                  }
                  <app-price [price]="retailPrice()" [type]="'retail'"></app-price>
                }
              </div>
            }
          </div>
          @if (!isRetailOnlyMode() || canRetailerAddToCart() || !isReviewing()) {
          <button mat-raised-button class="ReviewButton ThemeColorPrimary" (click)="reviewClicked()">
            <div class="Flexbox Align--center Gap--smaller">
              @if (!isReviewing()) {
                <span>Review</span>
              } @else {
                <span>Add to Cart</span>
              }
            </div>
          </button>
        }
        </div>
      </div>
  </div>
</div>